// components/PrivateRoute.js
import Unauthorized from 'pages/UnAuthorized';
import React from 'react';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';

const PrivateRoute = ({component, allowedRoles}) => {
  const auth = useAuthUser();

  const isAuthorized = allowedRoles?.includes(auth?.role);

  if(isAuthorized){
    return component
  }

  return <Unauthorized/>;

};

export default PrivateRoute;
